import { render, staticRenderFns } from "./UpgradeArc.vue?vue&type=template&id=358106d4&scoped=true&"
import script from "./UpgradeArc.vue?vue&type=script&lang=ts&"
export * from "./UpgradeArc.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeArc.vue?vue&type=style&index=0&id=358106d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358106d4",
  null
  
)

export default component.exports